// src/pages/CaseHistoryPage/fields/PhonemeInventory.js
import React from 'react';
import { HINDI_PHONEMES } from '../../../components/PhonemePicker';

/**
 * §9 sounds the child can say — the guardian's estimate.
 * Reuses the phoneme list that already drives exercise authoring, rather than
 * keeping a second copy of the 44 Hindi sounds.
 */
const GROUPS = [
    { key: 'vowels', hi: 'स्वर', en: 'Vowels', items: () => HINDI_PHONEMES.vowels },
    { key: 'stops', hi: 'स्पर्श', en: 'Stops', items: () => HINDI_PHONEMES.consonants.stops },
    { key: 'nasals', hi: 'नासिक्य', en: 'Nasals', items: () => HINDI_PHONEMES.consonants.nasals },
    { key: 'fricatives', hi: 'संघर्षी', en: 'Fricatives', items: () => HINDI_PHONEMES.consonants.fricatives },
    { key: 'liquids', hi: 'अंतस्थ', en: 'Approximants', items: () => HINDI_PHONEMES.consonants.liquids },
];

export default function PhonemeInventory({ value, onChange, onBlur, lang, disabled }) {
    const present = (value && value.present) || [];

    const toggle = (ipa) => {
        const next = present.includes(ipa) ? present.filter((p) => p !== ipa) : [...present, ipa];
        onChange({ source: 'parent_estimate', present: next });
        onBlur && onBlur();
    };

    const total = GROUPS.reduce((n, g) => n + g.items().length, 0);

    return (
        <div className="ch-inventory">
            <div className="ch-inventory-count">
                {present.length} / {total} {lang === 'en' ? 'marked' : 'चुने गए'}
            </div>
            {GROUPS.map((group) => (
                <div key={group.key} className="ch-inventory-group">
                    <span className="ch-inventory-label">{lang === 'en' ? group.en : group.hi}</span>
                    <div className="ch-inventory-row">
                        {group.items().map((p) => (
                            <button
                                type="button"
                                key={p.ipa}
                                className={`ch-phoneme ${present.includes(p.ipa) ? 'on' : ''}`}
                                onClick={() => toggle(p.ipa)}
                                disabled={disabled}
                                aria-pressed={present.includes(p.ipa)}
                                title={p.display}
                            >
                                {p.devanagari}
                            </button>
                        ))}
                    </div>
                </div>
            ))}
            <div className="ch-note blue">
                This is what the guardian reports. It is stored separately from the recorded test —
                a parent's estimate and a scored assessment are two different facts.
            </div>
        </div>
    );
}
